<template>
  <div class="collection-Records">
    <el-form :inline="true" label-width="90px">
      <el-row :gutter="26">
        <el-col
          :span="22"
          class="key-input"
          style="border-right: 1px #e5e6eb solid"
        >
          <el-row :span="22">
            <el-col :span="12">
              <el-form-item label="搜索">
                <el-input
                  clearable
                  v-model="searchInfo.code"
                  placeholder="订单编号"
                  size="mini"
                  suffix-icon="el-icon-search"
                  width="100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="会员内容" style="width: 100%">
                <el-select
                  clearable
                  v-model="searchInfo.idcVipId"
                  placeholder="请选择"
                  style="width: 100%"
                  size="mini"
                >
                  <el-option
                    v-for="item in vipSelectList"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :span="12">
              <el-form-item label="状态" style="width: 100%">
                <el-select
                  clearable
                  v-model="searchInfo.achieve"
                  placeholder="请选择"
                  style="width: 100%"
                  size="mini"
                >
                  <el-option
                    v-for="item in statusList"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="领取时间">
                <el-date-picker
                  clearable
                  v-model="dateNow"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 100%"
                  size="mini"
                  @change="handleDateChange"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="2" class="right-button">
          <el-button icon="el-icon-search" @click="search">查询</el-button>
          <el-button
            class="reset-btn"
            icon="el-icon-refresh-right"
            @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <div style="border-bottom: 1px #e5e6eb solid; margin: 20px 0"></div>
    <div class="download-btn">
      <el-button
        type="primary"
        icon="el-icon-download"
        size="small"
        @click="download"
        v-permission="'down_redeem'"
        >下载</el-button
      >
    </div>
    <!-- <el-row> -->
    <el-table
      v-loading="loading"
      empty-text="暂无数据"
      :data="tableData"
      style="width: 100%"
      size="small"
    >
      <el-table-column align="center" label="订单编号" width="150" prop="code">
      </el-table-column>
      <el-table-column align="center" label="会员" width="120" prop="idcVipId">
        <template slot-scope="scope">
          {{ vipAll[scope.row.idcVipId] || "--" }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="会员内容"
        prop="content"
        min-width="150"
      >
        <template slot-scope="scope">
          {{ scope.row.content || "--" }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户" prop="un" width="120">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top" width="auto">
            <div
              slot="reference"
              @click="toUserDetail(scope)"
              class="submitted"
            >
              {{ scope.row.un || "--" }}
            </div>
            <div
              style="
                display: flex;
                text-overflow: ellipsis;
                white-space: pre-line;
                cursor: pointer;
                color: #165dff;
                justify-content: center;
              "
            >
              <span @click="toUserDetail(scope)">
                {{ scope.row.un || "--" }}
              </span>
            </div>
          </el-popover>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="设备"
        prop="sourceId"
        min-width="130"
      >
        <template slot-scope="scope">
          {{ scope.row.sourceId || "--" }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" width="88">
        <template slot-scope="">
          {{ "已领取" }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="领取时间"
        prop="activeTime"
        width="150"
      >
        <template slot-scope="scope">
          {{ scope.row.activeTime || "--" }}
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="操作" prop="" width="150">
        <template slot-scope=""> </template>
      </el-table-column> -->
    </el-table>
    <div class="pagination">
      <el-pagination
        @current-change="changepagefn"
        :page-size="size"
        :current-page="page"
        @size-change="handleSizeChange"
        :page-sizes="[5, 10, 20, 50, 100]"
        layout="->,sizes,total,prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
// const _baseUrl = process.env.VUE_APP_activeDownloadUrl;
import { env } from "@/utils/util.js";
import { exportToExcel } from "@/utils/util";
export default {
  props: {
    promotionId: "",
  },
  data() {
    return {
      tableData: [],
      searchInfo: {
        status: "",
        idcVipId: "",
        code: "",
        createdAt: "",
      },
      vipSelectList: [],
      tableStatusText: {
        1: "挑战成功",
        "-1": "挑战失败",
      },
      size: 10,
      total: 0,
      page: 1,
      dateNow: "",
      loading: false,
      statusList: [
        {
          key: 4,
          value: "全部",
        },
        {
          key: 1,
          value: "成功",
        },
        {
          key: -1,
          value: "失败",
        },
        {
          key: 3,
          value: "挑战中",
        },
      ],
      curId: "",
      downloadBaseURL: "",
      vipAll: {},
      vipSelectList: [],
    };
  },
  created() {
    this.getDataList();
    const vipAll = localStorage.getItem("VIP_ALL");
    if (vipAll) {
      this.vipAll = JSON.parse(vipAll);

      for (const key in this.vipAll) {
        if (this.vipAll.hasOwnProperty(key)) {
          this.vipSelectList.push({
            key: key,
            value: this.vipAll[key],
          });
        }
      }
    }
  },
  mounted() {
    const url = env();
    this.downloadBaseURL = url.downloadUrl;
  },
  methods: {
    saveOpinion() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.submitAuditOpinion();
        } else {
          return false;
        }
      });
    },
    download() {
      let createdAt = "";
      if (this.dateNow)
        createdAt =
          `${this.dateNow[0]} 00:00:00` + "~" + `${this.dateNow[1]} 23:59:59`;

      this.$get("/vip/record", {
        page: 1,
        size: 10000,
        createdAt,
        ...this.searchInfo,
        source: 1,
      }).then((res) => {
        // console.log("res", res);
        if (res.data?.code === 1000) {
          const tableData = res.data?.data?.list;
          if (this.tableData.length) {
            exportToExcel(
              tableData.map((n, i) => ({
                序号: i + 1,
                订单编号: n.code,
                会员: this.vipAll[n.idcVipId] || "--",
                用户: n.un || n.mb || n.email,
                会员内容: n.content,
                设备: n.sourceId || "--",
                状态: "已领取",
                领取时间: n.activeTime,
              })),
              "领取记录"
            );
          }
        }
      });
    },
    // 查看用户详情
    toUserDetail(scope) {
      if (this.$jumpPerm("user_detail")) {
        this.$router.push({
          path: "/userDetail",
          query: {
            id: scope.row.userId,
            tabs: "first",
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    // 查看设备详情
    goDevDetail(id) {
      if (this.$jumpPerm("device_detail")) {
        this.mskflag = false;
        this.$router.push({
          path: "/devDetail",
          query: {
            id,
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    getDataList() {
      let createdAt = "";
      if (this.dateNow)
        createdAt =
          `${this.dateNow[0]} 00:00:00` + "~" + `${this.dateNow[1]} 23:59:59`;

      this.$get("/vip/record", {
        page: this.page,
        size: this.size,
        createdAt,
        ...this.searchInfo,
        source: 1,
      }).then((res) => {
        // console.log("res", res);
        if (res.data?.code === 1000) {
          this.tableData = res.data?.data?.list;
          this.total = res.data?.data?.count;
        }
      });
    },
    getStatusColor(value) {
      switch (value) {
        case 1:
          return { backgroundColor: "#00B42A" };
        case -1:
          return { backgroundColor: "#F53F3F" };
        default:
          return { backgroundColor: "#165DFF" };
      }
    },
    search() {
      this.page = 1;
      this.getDataList();
    },
    handleDateChange(dates) {
      if (dates && dates.length) {
        const regTime = `${dates[0]} 00:00:00` + "~" + `${dates[1]} 23:59:59`;
        this.searchInfo.createdAt = regTime;
      } else {
        this.searchInfo.createdAt = "";
      }
    },
    reset() {
      this.dateNow = "";
      this.searchInfo = {
        status: "",
        keyword: "",
        createdAt: "",
      };
      this.getDataList();
    },
    changepagefn(index) {
      this.page = index;
      this.getDataList(this.searchInfo);
    },
    handleSizeChange(val) {
      this.size = val;
      this.getDataList(this.searchInfo);
    },
  },
};
</script>

<style lang="less" scoped>
.collection-Records {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  // min-height: 100%;
  border-radius: 4px;
  padding: 20px;
  box-sizing: border-box;
}
.submitted {
  color: #165dff;
  cursor: pointer;
  width: 90px;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出隐藏 */
  text-overflow: ellipsis; /* 超出显示省略号 */
}
.download-btn {
  margin-bottom: 20px;
}
.el-popover {
  width: auto !important;
}
.right-button {
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  .el-button {
    width: 82px;
    height: 28px;
    background-color: #165dff;
    border-radius: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    margin-top: 5px;
  }
  .reset-btn {
    color: #4e5969;
    background-color: #f2f3f5;
    margin-left: 0 !important;
    margin-top: 13px;
  }
}
::v-deep .key-input .el-form-item__content {
  width: 100%;
  display: flex;
  align-items: center;
}
::v-deep .key-input1 {
  width: 100%;
}

::v-deep .key-input .el-form-item {
  margin-bottom: 0 !important;
}
::v-deep .el-form-item {
  display: flex !important;
}
.status-content {
  display: flex;
  width: 100%;
  align-items: center;
  // justify-content: space-between;
}
.status-color {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 6px;
  // background-color: #ff7d00;
}
.audit-opinion-desc {
  font-weight: 400;
  font-size: 14px;
  color: #1d2129;
}
.audit-opinion {
  display: block !important;
}
::v-deep .el-form--label-top .el-form-item__label {
  padding: 0px;
}
::v-deep .el-dialog__body {
  padding: 34px 20px 0px;
}
::v-deep .el-dialog__footer {
  text-align: right;
}
.dialog-footer {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
.dialog-btn {
  display: flex;
  width: 60px;
  height: 32px;
  background: #f2f3f5;
  border-radius: 2px;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: #4e5969;
  cursor: pointer;
}
.confirm-btn {
  background-color: #165dff;
  color: #ffffff;
  margin-left: 8px;
}
.pagination {
  margin-top: 15px;
}
.view-detail {
  color: #165dff;
  cursor: pointer;
  width: 100%;
  text-align: center;
}
::v-deep .el-form--inline .el-form-item {
  margin-right: 0px;
}
</style>
